import React, { Component } from 'react';
import 'Home/Components/NoticeDetails/noticedetails.css';
import config from 'config';
import HomeApiCall from 'HomeApiCall';
import ButtonLoader from 'Home/CommonResources/ButtonLoader/ButtonLoader';
import moment from 'moment';

class NoticeDetails extends Component {
    constructor(props) {
        super(props);

        this.state = {
            fetchingNotice: false,
            noticeDetails: {},
            noticeSequence: [],
            academicYear: this.props.academicYear
        };
    }
    
    componentDidMount() {
        // METHOD CALLED TO GET NOTICE DETAILS
        this.apiCallToGetNoticeDetails();
    }

    // API CALL METHOD TO GET NOTICE DETAILS
    apiCallToGetNoticeDetails = async () => {
        this.setState({
            fetchingNotice: true
        });

        let requestData = {
            'institute_id': config.institute_id,
            'user_id': '',
            'page_index': 1,
            'limit': 5,
            'filter_title': '',
            'filter_category': '',
            'filter_from_date': '',
            'filter_to_date': '',
            'filter_unread': '',
            'filter_bookmark': '',
            'filter_day_type': '',
            'filter_posted_by_id_array': [],
            'user_role': '',
            'academicYearId': this.state.academicYear,
            'sidArray': [],
            'categoryIdArray': []
        };

        let jsonResponse = await HomeApiCall.makeApiCall(
            'getNoticeList',
            requestData,
            '/api/notice/notice.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetNoticeDetails();
            }, 1000);
        }else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                
                this.setState({
                    noticeDetails: apiResult,
                    fetchingNotice: false,
                    noticeSequence: jsonResponse.APIResult.sequenceIdArray
                });
            }
        }
    }
    
    render() {
        return (
            <div className="noticeData">
                <a href={`${config.RootUrl}/modules/noticeboard`}>
                    <p style={{ fontSize: 15, fontWeight: 'bold', color: '#2979FF' }}>Notice</p>
                </a>
                <div className="noticeList scrollable">
                    {
                        this.state.fetchingNotice ?
                            <ButtonLoader />
                        :
                            Object.keys(this.state.noticeDetails).length > 0 ?
                                this.state.noticeSequence.map(noticeId => {
                                    let notice = this.state.noticeDetails[noticeId];
                                    let noticeDate = notice.formattedNoticeDate.split(',')[0];
                                    let noticeDay = noticeDate.split(' ')[0];
                                    let noticeMonth = noticeDate.split(' ')[1];
                                    let noticeTime = notice.formattedNoticeDate.split(' | ')[1];
                                    // let noticeDayName = moment(new Date(notice.noticeDate)).day();
                                    // noticeDayName = moment(noticeDayName-1).format('dddd');
                                    let noticeDayName = moment(notice.noticeDate).format('dddd');
                                    let attachments = notice.attachment.split(',');
                                    
                                    return(
                                        <div className="notice-details">
                                            <div className="notice-date">
                                                <p className="noticeDay">{noticeDay}</p>
                                                <p className="noticeMonth">{noticeMonth}</p>
                                            </div>
                                            <div className="notice-title">
                                                <p className="noticeTitle">{notice.title}</p>
                                                <p className="noticeTime">{noticeDayName} | {noticeTime}</p>
                                            </div>
                                            <div className="notice-attachment">
                                                {
                                                    (attachments[0].includes('png') || attachments[0].includes('jpeg') || attachments[0].includes('jpg')) &&
                                                        <img src={notice.attachmentPath + attachments[0]} height={40} width={40} style={{ borderRadius: 5 }} />
                                                }
                                            </div>
                                        </div>
                                    );
                                })
                            :
                                <p style={{ fontSize: 12, color: '#818181' }}>No notice yet posted.</p>
                    }
                </div>
            </div>
        );
    }
}

export default NoticeDetails;